export function removeSpaces(value: string): string { // TODO delete - obsolete due to replaceAll
  return value.replace(/ /g, '');
}

function fallbackCopyTextToClipboard(text: string): void {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  let successful = false;
  try {
    successful = document.execCommand('copy');
    // const msg = successful ? 'successful' : 'unsuccessful'; // throw error
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }
  document.body.removeChild(textArea);

  if(!successful) {
    throw new Error('copy failed');
  }
}

export function copyTextToClipboard(text: string): void {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(() => {
  }, (err) => {
    fallbackCopyTextToClipboard(text);
    console.error('Async: Could not copy text: ', err);
  });
}


export function getTextWidthInPx(text: string, font: string): number {
  const element = document.createElement('canvas');
  element.style.position = 'absolute';
  element.style.visibility = 'hidden';
  element.style.height = 'auto';
  element.style.width = 'auto';
  element.style.whiteSpace = 'nowrap';
  element.style.font = font;
  element.textContent = text;
  const ctx = element.getContext('2d');
  if (ctx) {
    ctx.font = font;
    const width = Math.round(ctx.measureText(text).width);
    element.remove();
    return width;
  }
  throw new Error('unknown error');
}

export function shorten(str: string, cutAtPixel: number, font: string = '12px Arial', shortIndicator: string = '(...)'): string {
  if (str.length === 0) {
    return '';
  }
  for (let i = 0; i < str.length; i++) {
    if (getTextWidthInPx(str.substr(0, i), font) > cutAtPixel) {
      return str.slice(0, i - 1) + shortIndicator;
    }
  }
  return str;
}
